import React, { useEffect, useState } from 'react';
import { withFirebase } from '../context';
import { AuthUserContext } from './index';

const withAuthentication = Component => {
	const WithAuthentication = (props) => {

		const { firebase } = props
		const [authUser, setAuthUser] = useState(JSON.parse(localStorage.getItem('authUser')))

		useEffect(() => {
			firebase.auth.onAuthStateChanged(user => {
				if (user) {
						localStorage.setItem('authUser', JSON.stringify(authUser));
						setAuthUser(user);
				} else {
						localStorage.removeItem('authUser');
						setAuthUser(null);
				}
			});
		})

		return (
			<AuthUserContext.Provider value={authUser} >
				<Component {...props} />
			</AuthUserContext.Provider>
		)
	}

	return withFirebase(WithAuthentication);
};

export default withAuthentication;
